var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed0049",
    d: "M16,5c5.728,0,10.442,4.402,10.949,10h4C30.431,7.195,23.934,1,16,1S1.569,7.195,1.051,15h4 C5.558,9.402,10.272,5,16,5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed0049",
    d: "M16,27c-5.728,0-10.442-4.402-10.949-10h-4C1.569,24.805,8.066,31,16,31s14.431-6.195,14.949-14 h-4C26.442,22.598,21.728,27,16,27z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 11,
    x: 14.5,
    y: 12.5,
    fill: "#0f518c"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    x: 14.5,
    y: 8.5,
    fill: "#0f518c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedInfo);
export default __webpack_public_path__ + "static/media/RedInfo.43d832e3fd38465772b4acb14a0eb891.svg";
export { ForwardRef as ReactComponent };